import React from 'react';

const Textarea = ({ name, type = 'text', placeholder, value, onChange }) => {
  return (
    <textarea
      type={type}
      name={name}
      id={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="appearance-none border rounded w-full h-[100px] text-[12px] py-[8px] px-[24px] resize-none text-gray-700 focus:placeholder-transparent focus:outline-none focus:shadow-outline "
    />
  );
};

export default Textarea;
